import { render } from "./CustomScrollbar.vue?vue&type=template&id=90c9bd80&scoped=true"
import script from "./CustomScrollbar.vue?vue&type=script&lang=js"
export * from "./CustomScrollbar.vue?vue&type=script&lang=js"

import "./CustomScrollbar.vue?vue&type=style&index=0&id=90c9bd80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c9bd80"]])

export default __exports__